$(document).ready(function () {
  $('#view-results').on('click', function(e) {
    e.preventDefault();
    //window.location.href="https://www.littlechonk.com/products/copy-of-the-maxine-one%E2%84%A2-bag-2";
      $("html, body").animate({ scrollTop: 0 }, "slow");
      return false;
      
  });

  $('.close-quiz').on('click', function(e){
    e.preventDefault();
    $('.take-quiz').removeClass('hide');
    $('#shopify-section-quiz-section').removeClass('reveal');
  });
  $('.take-quiz, .pro-svg-images').on('click', function(e) {
    e.preventDefault();
    $(this).addClass('hide');
    $('#shopify-section-quiz-section').addClass('reveal');
     var quizSection = $("#shopify-section-quiz-section").offset();
      $('html, body').animate({
          scrollTop: quizSection.top - 50
      }, 100);
    });
  
    // hidden things
    $(".form-business").hide();
    $("#successMessage").hide();
    // next button 
		
		
							var optionA, optionB, optionC, optionD, optionE, optionF;	
  var qq2, qq3;/*, qq2Size, qq3Size;*/
    $(".quiz-next").on({
        click: function () {
            // select any option
qq2 = $(".qq2 input:checked").val();
qq3 = $(".qq3 input:checked").val();

          
          //qq2Size = $(".qq2 input:checked").data('size');
          //qq3Size = $(".qq3 input:checked").data('size');
          //console.log(qq2Size);
          //console.log(qq3Size);


          /*if (qq2Size == '13') {
            $('.qq3-26, .qq3-27, .qq3-28, .qq3-29, .qq3-30').hide();
          } else {
            $('.qq3-26, .qq3-27, .qq3-28, .qq3-29, .qq3-30').show();
          }*/
/*
if ((qq2 === 'maximeOneSmall' && qq3 === 'maximeOneSmall')) {
    console.log('Product recommended is Maxime One Small');
    $('.size-m1s-message').addClass('active');  
    $('.size-m1-message').removeClass('active');
    $('.size-b1s-message').removeClass('active');    
    $('.size-b1-message').removeClass('active');  
    $('.size-other-message').removeClass('active');  
} else if ((qq2 === 'maximeOneSmall' && qq3 === 'maximeOneMedium') || 
           (qq2 === 'maximeOneMedium' && qq3 === 'maximeOneSmall') || 
           (qq2 === 'maximeOneMedium' && qq3 === 'maximeOneMedium')) {
    console.log('Product recommended is Maxime One Medium');
    $('.size-m1s-message').removeClass('active');  
    $('.size-m1-message').addClass('active');
    $('.size-b1s-message').removeClass('active');     
    $('.size-b1-message').removeClass('active');  
    $('.size-other-message').removeClass('active');  
} else if ((qq2 === 'maximeOneSmall' && qq3 === 'BrodieOneLarge') || 
           (qq2 === 'maximeOneMedium' && qq3 === 'BrodieOneLarge') || 
           (qq2 === 'BrodieOneLarge' && qq3 === 'maximeOneSmall') || 
           (qq2 === 'BrodieOneLarge' && qq3 === 'maximeOneMedium') || 
           (qq2 === 'BrodieOneLarge' && qq3 === 'BrodieOneLarge')) {
    console.log('Product recommended is Brodie One Large');
    $('.size-m1s-message').removeClass('active');  
    $('.size-m1-message').removeClass('active');
    $('.size-b1s-message').addClass('active');    
    $('.size-b1-message').removeClass('active');  
    $('.size-other-message').removeClass('active');  
} else if ((qq2 === 'maximeOneSmall' && qq3 === 'BrodieOneXL') || 
           (qq2 === 'maximeOneMedium' && qq3 === 'BrodieOneXL') || 
           (qq2 === 'BrodieOneLarge' && qq3 === 'BrodieOneXL') || 
           (qq2 === 'BrodieOneXL' && qq3 === 'maximeOneSmall') || 
           (qq2 === 'BrodieOneXL' && qq3 === 'maximeOneMedium') || 
           (qq2 === 'BrodieOneXL' && qq3 === 'BrodieOneLarge') || 
           (qq2 === 'BrodieOneXL' && qq3 === 'BrodieOneXL')) {
    console.log('Product recommended is Brodie One XL');
    $('.size-m1s-message').removeClass('active');  
    $('.size-m1-message').removeClass('active');
    $('.size-b1s-message').removeClass('active');    
    $('.size-b1-message').addClass('active');  
    $('.size-other-message').removeClass('active');  
} else if (qq2 === 'other' && qq3 === 'other') {
    console.log('Please contact support for custom sizing');
    $('.size-m1s-message').removeClass('active');  
    $('.size-m1-message').removeClass('active');
    $('.size-b1s-message').removeClass('active');    
    $('.size-b1-message').removeClass('active');  
    $('.size-other-message').addClass('active');  
} else {
    console.log('No matching product found. Please adjust your selections.');
    $('.size-m1s-message').removeClass('active');  
    $('.size-m1-message').removeClass('active');
    $('.size-b1s-message').removeClass('active');    
    $('.size-b1-message').removeClass('active');  
    $('.size-other-message').addClass('active');  
}*/

if (qq2 === 'maximeOneSmall' && qq3 === 'maximeOneSmall') {
    console.log('Product recommended is Maxine One S');
    $('.size-m1s-message').addClass('active');  
    $('.size-m1-message').removeClass('active');
    $('.size-b1s-message').removeClass('active');    
    $('.size-b1-message').removeClass('active');  
    $('.size-other-message').removeClass('active');
    
} else if ((qq2 === 'maximeOneSmall' && qq3 === 'maximeOneMedium') || 
           (qq2 === 'maximeOneMedium' && qq3 === 'maximeOneSmall') || 
           (qq2 === 'maximeOneMedium' && qq3 === 'maximeOneMedium')) {
    console.log('Product recommended is Maxine One M');
    $('.size-m1s-message').removeClass('active');  
    $('.size-m1-message').addClass('active');
    $('.size-b1s-message').removeClass('active');    
    $('.size-b1-message').removeClass('active');  
    $('.size-other-message').removeClass('active');  

} else if ((qq2 === 'BrodieOneLarge' && qq3 === 'BrodieOneLarge') || 
           (qq2 === 'BrodieOneLarge' && qq3 === 'maximeOneMedium')) {
    console.log('Product recommended is Brodie One L');
    $('.size-m1s-message').removeClass('active');  
    $('.size-m1-message').removeClass('active');
    $('.size-b1s-message').addClass('active');    
    $('.size-b1-message').removeClass('active');  
    $('.size-other-message').removeClass('active');  

} else if ((qq2 === 'BrodieOneXL' && qq3 === 'BrodieOneLarge') || 
           (qq2 === 'BrodieOneXL' && qq3 === 'maximeOneMedium')) {
    console.log('Product recommended is Brodie One XL');
    $('.size-m1s-message').removeClass('active');  
    $('.size-m1-message').removeClass('active');
    $('.size-b1s-message').removeClass('active');    
    $('.size-b1-message').addClass('active');  
    $('.size-other-message').removeClass('active');  

} else if (qq2 === 'other' && qq3 === 'other') {
    console.log('Uh Oh!...');
    $('.size-m1s-message').removeClass('active');  
    $('.size-m1-message').removeClass('active');
    $('.size-b1s-message').removeClass('active');    
    $('.size-b1-message').removeClass('active');  
    $('.size-other-message').addClass('active');  

} else {
    console.log('Uh Oh!...');
    $('.size-m1s-message').removeClass('active');  
    $('.size-m1-message').removeClass('active');
    $('.size-b1s-message').removeClass('active');    
    $('.size-b1-message').removeClass('active');  
    $('.size-other-message').addClass('active');  
}
          

          
          /*if (qq2 == 'size-m1' && qq3 == 'size-m1') {
           // window.location.href = "https://www.littlechonk.com/products/copy-of-the-maxine-one%E2%84%A2-bag-2?variant=43491526738134";
            //window.location.href = "https://www.littlechonk.com/products/copy-of-the-maxine-one%E2%84%A2-bag-2?variant=43491526705366";
            $('.size-m1-message').addClass('active');
            $('.size-m1s-message').removeClass('active');
            $('.size-other-message').removeClass('active');
          } else if (qq2 == 'size-m1' && qq3 == 'size-m1s') {
            //window.location.href = "https://www.littlechonk.com/products/copy-of-the-maxine-one%E2%84%A2-bag-2?variant=43491526738134";
            //window.location.href = "https://www.littlechonk.com/products/copy-of-the-maxine-one%E2%84%A2-bag-2?variant=43491526705366";
            $('.size-m1-message').addClass('active');
            $('.size-m1s-message').removeClass('active');
            $('.size-other-message').removeClass('active');
          } else if (qq2 == 'size-m1s' && qq3 == 'size-m1') {
            //window.location.href = "https://www.littlechonk.com/products/copy-of-the-maxine-one%E2%84%A2-bag-2?variant=43491526738134";
            //window.location.href = "https://www.littlechonk.com/products/copy-of-the-maxine-one%E2%84%A2-bag-2?variant=43491526705366";
            $('.size-m1-message').removeClass('active');
            $('.size-m1s-message').addClass('active');
            $('.size-other-message').removeClass('active');
          } else if (qq2 == 'size-m1s' && qq3 == 'size-m1s') {
            //window.location.href = "https://www.littlechonk.com/products/copy-of-the-maxine-one%E2%84%A2-bag-2?variant=43491526738134";
            //window.location.href = "https://www.littlechonk.com/products/copy-of-the-maxine-one%E2%84%A2-bag-2?variant=43491526705366";
            $('.size-m1-message').removeClass('active');
            $('.size-m1s-message').addClass('active');
            $('.size-other-message').removeClass('active');
          } else if (qq2 == 'other' || qq3 == 'other') {
            //window.location.href = "https://www.littlechonk.com/products/copy-of-the-maxine-one%E2%84%A2-bag-2?variant=43491526738134";
            //window.location.href = "https://www.littlechonk.com/products/copy-of-the-maxine-one%E2%84%A2-bag-2?variant=43491526705366";
            $('.size-m1-message').removeClass('active');
            $('.size-m1s-message').removeClass('active');
            $('.size-other-message').addClass('active');
          }*/
/*


						 optionA = $("input[data-val1='A']:checked").length;
						 optionB = $("input[data-val2='B']:checked").length;
						 optionC = $("input[data-val3='C']:checked").length;
						 optionD = $("input[data-val4='D']:checked").length;
						 optionE = $("input[data-val5='E']:checked").length;
						 optionF = $("input[data-val6='F']:checked").length;

          
						console.log('option A:'+optionA);
						console.log('option B:'+optionB);
						console.log('option C:'+optionC);
						console.log('option D:'+optionD);
						console.log('option E:'+optionE);
						console.log('option F:'+optionF);
						
						$('.optionA').text(optionA);
						$('.optionB').text(optionB);
						$('.optionC').text(optionC);
						$('.optionD').text(optionD);
						$('.optionE').text(optionE);
						$('.optionF').text(optionF);*/

              
            var getValue = $(this).parents(".row").find(".option-block").hasClass("active-option");          
            var getValue2 = $(this).hasClass('confirm');
            var getSizeTypeCm = $('input#q1a1');
            var getSizeTypeIn = $('input#q1a2');
          
            if ((getSizeTypeIn).is(':checked')) {
              $('.qq2').removeClass('cm-active').addClass('in-active');
              $('.qq3').removeClass('cm-active').addClass('in-active');
            }
            if ((getSizeTypeCm).is(':checked')) {
              $('.qq2').removeClass('in-active').addClass('cm-active');
              $('.qq3').removeClass('in-active').addClass('cm-active');
            }
            if (getValue2) {
              var quizSection = $("#shopify-section-quiz-section").offset();
              $('html, body').animate({
                scrollTop: quizSection.top - 50
              }, 100);
            }

          
            if (getValue) {
                $("#progressBar").find(".active").next().addClass("active");
								$("#progressBar").find(".active").prev().addClass("valid");
                $("#alertBox").addClass("d-none");
                $(this).parents(".row").fadeOut(function () {
                    $(this).next(".row").fadeIn();
                });
                $(this).removeClass('notValid');						
            } else {
							$(this).addClass('notValid');
                           var quizSection = $("#shopify-section-quiz-section").offset();
                            $('html, body').animate({
                                scrollTop: quizSection.top - 50
                            }, 100);
               $("#alertBox").removeClass("d-none");							 
            }
        }
    });
    // back button
    $(".back").on({
        click: function () {
            $("#progressBar .active").last().removeClass("active").removeClass('valid');
            $(this).parents(".row").fadeOut("slow", function () {
                $(this).prev(".row").fadeIn("slow");
            });
        }
    });
  
    //finish button
  /*
    $(".submit-button").on({
        click: function () {          
            //$("#wizardRow").fadeOut(300);
            //$(this).parents(".row").children("#successForm").fadeOut(300);

          if (optionA > optionB && optionA > optionC && optionA > optionD && optionA > optionE && optionA > optionF) {
            window.location.href = "WEB";
            var setProfile = "bookworm";
          }

          else if (optionB > optionA && optionB > optionC && optionB > optionD && optionB > optionE && optionB > optionF) {
            window.location.href = "ADD";
            var setProfile = "crisp-classic";
          }  

          $("#successMessage").fadeIn(3000);

        }
     
    });*/
            

		
    $(".option-block").on({
        click: function (e) {
				
					var limit = $(this).parent('.options-container');
						
						if (limit.hasClass('limit2')) {
							var check = $('.limit2').find('input[type=checkbox]:checked').length;
							console.log(check);
							if (check > 2) {
								$('.only2options').removeClass('d-none');								
								$('.limit2 .option-block').not('.active-option').addClass('disabled');
							}
							if (check <= 2) {								
								$('.only2options').addClass('d-none');								
								$('.limit2 .disabled').removeClass('disabled');
							}							
						}					
				 
						var qType = $(this).find('input');						
						qType.prop('checked');
			
						if (qType.is(':radio')) {							
							$(this).parent(".options-container").children(".option-block").siblings().removeClass("active-option");				
							$(this).addClass("active-option");
							
						} 
						
						if (qType.is(':checkbox')) {												
							if(qType.is(':checked')){
								if ($(this).hasClass('disabled')){
									e.preventDefault();
								} else {
								$(this).addClass("active-option");
								}
								
							}else{
							 $(this).removeClass("active-option");
							}
						}
									
									
						
						
					
				
            //$(this).parent(".options-container").children(".option-block").siblings().removeClass("active-option");				
            //$(this).addClass("active-option");
        }
    });
    //back to wizard
    $(".back-to-wizard").on({
        click: function () {
            location.reload(true);
        }
    });
});